import { render } from "./CkeditorModule.vue?vue&type=template&id=06647ebe&scoped=true"
import script from "./CkeditorModule.vue?vue&type=script&lang=ts"
export * from "./CkeditorModule.vue?vue&type=script&lang=ts"

import "./CkeditorModule.vue?vue&type=style&index=0&id=06647ebe&lang=css"
import "./CkeditorModule.vue?vue&type=style&index=1&id=06647ebe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06647ebe"

export default script